import { render, staticRenderFns } from "./dealer-view-dialog.vue?vue&type=template&id=bda118c8&scoped=true"
import script from "./dealer-view-dialog.vue?vue&type=script&lang=js"
export * from "./dealer-view-dialog.vue?vue&type=script&lang=js"
import style0 from "./dealer-view-dialog.vue?vue&type=style&index=0&id=bda118c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda118c8",
  null
  
)

export default component.exports